import { createSlice } from "@reduxjs/toolkit";
import { t } from "i18next";

const initialState = { open: false, message: "", status: "" };

const notificationSlice = createSlice({
  name: "dialogDispositivo",
  initialState,
  reducers: {
    notificationOpen: (state, action) => {
      return {
        ...state,
        open: true,
        message: action.payload.message,
        severity: action.payload.status
      };
    },
    notificationClose: (state) => {
        return {
          ...state,
          open: false,
        };
      },
  },
});


export const OpenAndCloseNotification = (state) => (dispatch) => {
  dispatch(notificationOpen({message: t("sessionExpiryWarning"), status: "warning"}));
} 

export const { notificationOpen, notificationClose } = notificationSlice.actions;

const { reducer } = notificationSlice;

export default reducer;
